import actionTypes from '../../shared/constants/actionTypes';

export function taskData(taskData) {
    return { type: actionTypes.TASKDATA, data: taskData };
}
